var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vuestic-file-upload-container" }, [
    _c(
      "div",
      {
        staticClass: "vuestic-file-upload-container__field",
        class: {
          "vuestic-file-upload-container__field--dropzone": _vm.dropzone,
        },
      },
      [
        _vm.dropzone
          ? _c(
              "div",
              { staticClass: "vuestic-file-upload-container__field__text" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("fileUpload.dragNdropFiles")) +
                    "\n    "
                ),
              ]
            )
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "btn btn-primary btn-micro",
            attrs: { type: "button", disabled: _vm.disabled },
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("fileUpload.uploadFile")) + "\n    "
            ),
          ]
        ),
        _c("input", {
          ref: "fieldInput",
          staticClass: "vuestic-file-upload-container__field__input",
          attrs: {
            type: "file",
            accept: _vm.fileTypes,
            multiple: _vm.type !== "single",
            disabled: _vm.disabled,
          },
          on: { change: _vm.changeFieldValue },
        }),
      ]
    ),
    _c(
      "div",
      { staticClass: "vuestic-file-upload-container__main" },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }